// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2foX3","file":"styles_file__1_Uw7"};